<template>
  <div>
    <b-form-group label="Filter">
      <b-form-input v-model="filter" type="search"></b-form-input>
    </b-form-group>
    <UmDbCardList :cards="cards" :filter="filter" stickyHeader="80vh" />
  </div>
</template>

<script type="text/javascript">
import UmDbCardList from "@/components/UmDb/UmDbCardList";

export default {
  name: "UmDbCardListView",
  metaInfo: {
    title: "Cards | UmDb"
  },
  components: { UmDbCardList },
  data() {
    return {
      filter: ""
    };
  },
  computed: {
    cards() {
      return this.$store.state.umDbCardList;
    }
  }
};
</script>
